<div class="wnl-header">
  <p>WNL: Skin warm, clean, dry and intact. Pink mucus membranes.</p>
  <mat-checkbox [checked]="wnlManager.allWNL" [indeterminate]="wnlManager.someWNL()"
    (change)="wnlManager.setAllWNL($event.checked)">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container">
  <assessment-row title="Skin Appearance">
    <emr-checkbox-group [hasWNL]="true" [control]="formGroup().controls.skinAppearance"
      [options]="skinAppearanceOptions" [default]="skinAppearanceDefault" wnlLabel="WNL"
      [(wnl)]="wnlManager.controlColl['skinAppearance'].wnl" (wnlChange)="wnlManager.updateAllWNL()" />
    @if (needCommentBox){
    <emr-input type="text" label="Comments" [control]="formGroup().controls.skinAppearanceComment" />
    }
  </assessment-row>

  <h2>Wounds</h2>

  <assessment-row title="Location">
    <emr-input type="text" width="50%" [control]="formGroup().controls.location" />
  </assessment-row>

  <assessment-row title="Staging">
    <emr-input type="select" [control]="formGroup().controls.staging" [options]="stagingOptions" />
  </assessment-row>

  <assessment-row title="Wound Care">
    <emr-checkbox-group [control]="formGroup().controls.care" [options]="careOptions" />
  </assessment-row>
</div>